__turbopack_context__.v({
  "caption": "HeroSection-module___CeSFW__caption",
  "content": "HeroSection-module___CeSFW__content",
  "head": "HeroSection-module___CeSFW__head",
  "headContainer": "HeroSection-module___CeSFW__headContainer",
  "parentContainer": "HeroSection-module___CeSFW__parentContainer",
  "root": "HeroSection-module___CeSFW__root",
});
